import Brand from "../../../model/brand/Brand";

/**
 * Fetch brands successful action.
 */
export const BRANDS_FETCHED = "BRANDS_FETCHED";
export type BRANDS_FETCHED = { brands: Array<Brand> }

/**
 * Create brand successful action.
 */
export const BRAND_CREATED = "BRAND_CREATED";
export type BRAND_CREATED = { brand: Brand }

/**
 * Create brand successful action.
 */
export const BRAND_UPDATED = "BRAND_UPDATED";
export type BRAND_UPDATED = { brand: Brand }
